<template>
  <div id="app">
    <div class="center-app">
      <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  methods: {},
};
</script>

<style>
@font-face {
  font-family: sukhumvit;
  src: local("sukhumvit"), url(./assets/sukhumvit.ttf);
}
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  font-family: sukhumvit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* background: #45107C;#1C8CA4 */
  background: linear-gradient(180deg, #45107c 0%, #1c8ca4 100%);
}

.center-app {
  padding-top: 40px;
  max-width: 480px;
  margin: 0 auto;
  overflow: hidden;
  height: 100%;
  min-height: 100vh;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.base-btn {
  border: none;
  color: #008ec3;
  padding: 10px 40px;
  border-radius: 30px;
  font-weight: bold;
  background: linear-gradient(180deg, #faf8c9 0%, #c5faf1 100%);
  margin-bottom: 50px;
}
</style>
